module.exports = __webpack_public_path__ + "static/img/Front Eureka_6.76f0a2a6.png";